import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Contact, Vendor, VendorType } from "../types";

interface State {
  isBootstrapped: boolean;
  isAdmin: boolean;
  vendors: Vendor[];
  vendorTypes: VendorType[];
  contacts: Contact[];
}

const initialState: State = {
  isBootstrapped: false,
  isAdmin: false,
  vendors: [],
  vendorTypes: [],
  contacts: [],
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsBootstrapped: (state, action: PayloadAction<boolean>) => {
      state.isBootstrapped = action.payload;
    },
    setIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setVendors: (state, action: PayloadAction<Vendor[]>) => {
      state.vendors = action.payload;
    },
    setVendorTypes: (state, action: PayloadAction<VendorType[]>) => {
      state.vendorTypes = action.payload;
    },
    setContacts: (state, action: PayloadAction<Contact[]>) => {
      state.contacts = action.payload;
    },
  },
});

export const {
  setIsBootstrapped,
  setIsAdmin,
  setVendors,
  setVendorTypes,
  setContacts,
} = appSlice.actions;

export default appSlice.reducer;
